import { render, staticRenderFns } from "./tableComLightweight.vue?vue&type=template&id=17b8aaec&scoped=true"
import script from "./tableComLightweight.vue?vue&type=script&lang=js"
export * from "./tableComLightweight.vue?vue&type=script&lang=js"
import style0 from "./tableComLightweight.vue?vue&type=style&index=0&id=17b8aaec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8aaec",
  null
  
)

export default component.exports